// @greenlight-spec: 11-observability.md#egress-reachability
// @greenlight-spec: 28-it-dashboard-ui.md
import { z } from 'zod';
export const EgressDestinationGroupSchema = z.enum(['greenlight', 'integration']);
export const EgressCheckStageSchema = z.enum(['blocked', 'dns', 'tcp', 'tls', 'http']);
export const EgressDestinationResultSchema = z.object({
    group: EgressDestinationGroupSchema,
    name: z.string(),
    /** The URL requested, or `host:port` for a database. */
    address: z.string(),
    /** Why Greenlight needs it; null for an integration. */
    reason: z.string().nullable(),
    /** The integration's display name; null for Greenlight's own destinations. */
    integrationName: z.string().nullable(),
    status: z.enum(['reachable', 'blocked']),
    /** The stage that failed; null when reachable. */
    stage: EgressCheckStageSchema.nullable(),
    message: z.string().nullable(),
});
export const EgressReachabilitySchema = z.discriminatedUnion('applies', [
    // Absent unless this install's egress leaves through the customer's firewall.
    z.object({ applies: z.literal(false) }),
    z.object({
        applies: z.literal(true),
        /** A check is running now; `destinations` are still the last completed check's. */
        checking: z.boolean(),
        /** When the last completed check finished; null before the first. */
        checkedAt: z.string().datetime().nullable(),
        /** The most recent check failed before finishing; `destinations` are from the one before it. */
        lastCheckFailed: z.boolean(),
        destinations: z.array(EgressDestinationResultSchema),
    }),
]);
//# sourceMappingURL=egress.js.map